export default __webpack_public_path__ + "static/media/Metallicrain_primary.06a08396.jpg";